/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetCountryListQueryResponse, GetCountryListQueryParams, GetCountryList400, GetCountryList401, GetCountryList500 } from "../entities/GetCountryList";

function getGetCountryListUrl() {
  const res = { method: 'GET', url: `/api/v1/countries` as const }
  return res
}

/**
 * @description Возвращает список стран с курсорной пагинацией.
 * **Требования:**
 * - Аутентификация по заголовкам `user-id` и `city-id`
 * **Режимы:**
 * - без `name` — полный справочник: сначала популярные
 * (`popularity_score` по убыванию), при равном score и для остальных —
 * по `name` по возрастанию. Курсор: `{id}_{popularity_score}_{name}`
 * (например, `42_100_Russia`).
 * - с `name` — поиск по подстроке (`LIKE %name%`), сортировка по `name`
 * по возрастанию, затем по `id`. Курсор: `{id}_{name}`
 * (например, `15_Belarus`).
 * **Пагинация:**
 * - `limit` — размер страницы (1–100, по умолчанию 10)
 * - `cursor` — курсор следующей страницы из `next_cursor` предыдущего ответа
 * - если есть ещё данные, `has_more=true` и возвращается `next_cursor`
 * @summary Справочник стран
 * {@link /api/v1/countries}
 */
export async function getCountryList(params?: GetCountryListQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetCountryListQueryResponse, ResponseErrorConfig<GetCountryList400 | GetCountryList401 | GetCountryList500>, unknown>({ method : "GET", url : getGetCountryListUrl().url.toString(), params, ... requestConfig })
  return res.data
}